import React, { ReactNode, FunctionComponent } from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { Overlay, Root } from './useStyles'

export interface ProgressOverlayProps {
  readonly children?: ReactNode
  readonly progressSize?: number | string
  readonly visible?: boolean
  readonly fullWidth?: boolean
}

const ProgressOverlay: FunctionComponent<ProgressOverlayProps> = (
  props: ProgressOverlayProps
) => {
  const { children, progressSize, visible, fullWidth } = props
  return (
    <Root fullWidth={fullWidth}>
      {children}
      {visible && (
        <Overlay>
          <CircularProgress size={progressSize} />
        </Overlay>
      )}
    </Root>
  )
}

ProgressOverlay.defaultProps = {
  fullWidth: true,
}

export default ProgressOverlay
